import yup from 'src/libraries/validator.library';

export const TailNumberShape = {
  tailNumber: yup.string().required(),
  tailId: yup.number(),
  Operators: yup.array().of(
    yup
      .object({
        operatorId: yup.number().required(),
        name: yup.string().required(),
        email: yup.string().nullable(),
        activeFlag: yup.boolean(),
        dispatchFlag: yup.boolean(),
      })
      .defined()
  ),
};

export const TailNumberSchema = yup
  .object()
  .shape({
    ...TailNumberShape,
  })
  .defined();

export const TailNumberListSchema = yup
  .object({
    tailNumbers: yup
      .object({
        count: yup.number(),
        rows: yup
          .array()
          .of(
            yup
              .object()
              .shape({
                ...TailNumberShape,
              })
              .defined()
          )
          .defined(),
      })
      .defined(),
  })
  .defined();

export const TailNumberFormSchema = yup
  .object()
  .shape({
    ...TailNumberShape,
  })
  .defined();

export const TailNumberResponsePayloadSchema = yup
  .object({
    tailNumber: yup
      .object({
        tailId: yup.number(),
        tailNumber: yup.string(),
      })
      .defined(),
  })
  .defined();

export type ITailNumber = yup.InferType<typeof TailNumberSchema>;
export type ITailNumberList = yup.InferType<typeof TailNumberListSchema>;
export type ITailNumberForm = yup.InferType<typeof TailNumberFormSchema>;
